import React, { useEffect, useState } from "react";
import { MdAirplanemodeActive } from "react-icons/md";
import AdminDashboardNavbar from "../../../../../components/ui/Admin/AdminDashboardNavbar";
import Chart from "react-apexcharts";
import AdminTopBar from "../../../../../components/ui/Admin/AdminTopBar";
import { AiFillDelete } from "react-icons/ai";
import {
  deleteVendorById,
  fetchSuspendedVendors,
  fetchVendors,
  rejectVendorApplication,
  suspendVendorById,
  unsuspendVendorById,
} from "../../../../../redux/slices/adminSlice";
import { useDispatch, useSelector } from "react-redux";
import { ImSpinner2 } from "react-icons/im";
import { Helmet } from "react-helmet";
import Modal from "react-modal";
import SimpleProfileCard from "../../../../../components/ui/SimpleProfileCard";
import { FaXmark } from "react-icons/fa6";
import moment from "moment";
import GoogleMapsWithDirections from "../../../../../components/ui/GoogleMapsWithDirection";

function AdminDashboardVendorsPage() {
  // Mobile navbar handler
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const dispatch = useDispatch();
  const { isLoading, vendors, suspendedVendors, vendorData, token, admin } =
    useSelector((store) => store.admin);

  // Chart Setup
  const [vendorDataByMonth, setVendorDataByMonth] = useState();
  const state = {
    options: {
      chart: {
        id: "apexchart-example",
        fontFamily: "Poppins",
        style: {
          fontSize: ".8rem",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        colors: ["#E2B442", "#262471"],
      },
      fill: {
        colors: ["#E2B442", "#262471"],
        pattern: {
          style: "circles",
          strokeWidth: 1,
          height: 1,
          width: 1,
        },
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yaxis: {
        labels: {
          show: true,
          minWidth: 0,
          maxWidth: 160,
          style: {
            colors: [],
            fontSize: "30px",
            fontFamily: "Poppins",
            cssClass: "text-xs",
          },
          formatter: (value) => {
            const formattedValue = Intl.NumberFormat("en-US", {}).format(value);
            return formattedValue;
          },
        },
      },
    },
    series: [
      {
        name: "",
        data: vendorDataByMonth,
      },
    ],
  };

  // Fetch Vendors
  useEffect(() => {
    dispatch(fetchVendors(token));
    dispatch(fetchSuspendedVendors(token));
  }, [token]);

  // Configure vendorDataByMonth
  useEffect(() => {
    function prepareDriverDataByMonth() {
      let preparedData = [];
      for (let i = 1; i <= 12; i++) {
        vendorData?.forEach((data) => {
          if (data?._id?.month == i) {
            preparedData.push(data?.count);
          } else {
            preparedData.push(0);
          }
        });
      }
      setVendorDataByMonth(preparedData);
      console.log("PREAPRED DATA:", preparedData);
    }

    prepareDriverDataByMonth();
  }, [token, vendorData]);

  // function to handle deleting a vendor
  function deleteVendor(vendorId) {
    dispatch(deleteVendorById({ token, vendorId }));
  }

  // function to handle suspending a vendor
  function handleSuspendVendor(vendorId) {
    dispatch(suspendVendorById({ token, vendorId }));
  }

  // function to handle unsuspending a vendor
  function handleUnsuspendVendor(vendorId) {
    dispatch(unsuspendVendorById({ token, vendorId }));
  }

  // function to handle suspending a vendor
  function handleRejectVendorApplication(vendorId) {
    dispatch(rejectVendorApplication({ token, vendorId }));
  }

  // Vendor details modal
  const [isVendorDetailModalOpen, setIsVendorDetailModalOpen] = useState(false);
  const [currentVendor, setCurrentVendor] = useState();

  // Tabs
  const [isOverview, setIsOverview] = useState(true);
  const [isJobs, setIsJobs] = useState(false);
  const [isFleet, setIsFleet] = useState(false);
  const [isDrivers, setIsDrivers] = useState(false);

  return (
    <div className="">
      <Helmet>
        <title>Manage Vendors | Shuttlelane Portal Admin Dashboard</title>
      </Helmet>

      {/* Navbar here */}
      <AdminDashboardNavbar
        link="users"
        sublink="manage-vendors"
        isNavbarOpen={isNavbarOpen}
        setIsNavbarOpen={setIsNavbarOpen}
      />

      {/* Vendor Detail Modal */}
      <Modal
        isOpen={isVendorDetailModalOpen}
        onRequestClose={() => setIsVendorDetailModalOpen(false)}
        className="flex h-full min-h-screen justify-center items-center lg:px-24 px-7 overflow-y-scroll"
      >
        <div className="bg-white shadow-lg rounded-lg text-shuttlelaneBlack w-full p-7 px-10 h-[90vh] overflow-y-scroll shuttlelaneScrollbar">
          <div className="flex items-center justify-between">
            <div className="border-b-[1px] border-b-slate-100 w-full pb-4">
              <h4 className="font-semibold">Vendor Details</h4>
              <small>{currentVendor?.companyName}</small>
            </div>

            <FaXmark
              size={20}
              onClick={() => setIsVendorDetailModalOpen(false)}
              className="cursor-pointer"
            />
          </div>

          {/* Profile card */}
          <div className="w-full mt-10">
            <div className="flex flex-col gap-y-5 gap-x-4">
              <SimpleProfileCard user={currentVendor} />
            </div>
          </div>

          {/* Tabs */}
          {/* Overview */}
          {/* Jobs */}
          <div className="mt-10">
            {/* Options */}
            <div className="mt-9 flex justify-between items-baseline pb-1 transition-all border-b-[.3px] border-b-gray-200">
              <div className="flex items-center gap-x-10 gap-y-4 flex-wrap">
                <span
                  onClick={() => {
                    setIsOverview(true);
                    setIsJobs(false);
                    setIsFleet(false);
                    setIsDrivers(false);
                  }}
                  className={`text-xs cursor-pointer transition-all ${
                    isOverview
                      ? "font-semibold text-shuttlelaneBlack border-b-2 border-b-shuttlelaneBlack"
                      : "text-gray-400"
                  }`}
                >
                  Overview
                </span>
                <span
                  onClick={() => {
                    setIsOverview(false);
                    setIsJobs(false);
                    setIsFleet(true);
                    setIsDrivers(false);
                  }}
                  className={`text-xs cursor-pointer transition-all ${
                    isJobs
                      ? "font-semibold text-shuttlelaneBlack border-b-2 border-b-shuttlelaneBlack"
                      : "text-gray-400"
                  }`}
                >
                  Fleet
                </span>
                <span
                  onClick={() => {
                    setIsOverview(false);
                    setIsJobs(false);
                    setIsFleet(false);
                    setIsDrivers(true);
                  }}
                  className={`text-xs cursor-pointer transition-all ${
                    isJobs
                      ? "font-semibold text-shuttlelaneBlack border-b-2 border-b-shuttlelaneBlack"
                      : "text-gray-400"
                  }`}
                >
                  Drivers
                </span>
                <span
                  onClick={() => {
                    setIsOverview(false);
                    setIsJobs(true);
                    setIsFleet(false);
                    setIsDrivers(false);
                  }}
                  className={`text-xs cursor-pointer transition-all ${
                    isJobs
                      ? "font-semibold text-shuttlelaneBlack border-b-2 border-b-shuttlelaneBlack"
                      : "text-gray-400"
                  }`}
                >
                  All Jobs
                </span>
              </div>
            </div>

            {/* Overview */}
            {isOverview && (
              <div className="h-full mt-10 flex flex-col gap-y-5 pb-20">
                <div className="flex flex-col">
                  <p className="font-semibold text-shuttlelaneBlack">
                    Company Information
                  </p>
                  <small className="text-sm text-gray-400">
                    Company Name: {currentVendor?.companyName}
                  </small>
                  <small className="text-sm text-gray-400">
                    Email Address: {currentVendor?.companyEmail}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Opening Hours:{" "}
                    {currentVendor?.isOpen24Hours
                      ? "Opens 24 hours"
                      : moment(currentVendor?.openingHours)?.format("HH:MM A")}
                  </small>
                  {!currentVendor?.isOpen24Hours && (
                    <small className="text-sm text-gray-400 mt-1">
                      Closing Hours:{" "}
                      {moment(currentVendor?.openingHours)?.format("HH:MM A")}
                    </small>
                  )}
                  <small className="text-sm text-gray-400 mt-1">
                    Address: {currentVendor?.address}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    City: {currentVendor?.city}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Country: {currentVendor?.country}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Operating Cities:{" "}
                    {currentVendor?.operatingCities?.map(
                      (city) => `${city?.cityName}. `
                    )}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Fleet Type:{" "}
                    {currentVendor?.fleetType?.map(
                      (fleetType) => `${fleetType}. `
                    )}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Fleet Size: {currentVendor?.fleetSize}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Bank Name: {currentVendor?.bank}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Account Number: {currentVendor?.accountNumber}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Account Name: {currentVendor?.accountName}
                  </small>
                </div>

                <div className="flex flex-col">
                  <p className="font-semibold text-shuttlelaneBlack">
                    Contact Information
                  </p>
                  <small className="text-sm text-gray-400">
                    Full Name: {currentVendor?.contactName}
                  </small>
                  <small className="text-sm text-gray-400">
                    Email Address: {currentVendor?.contactEmail}
                  </small>
                  <small className="text-sm text-gray-400">
                    Mobile: {currentVendor?.contactMobile}
                  </small>
                </div>
              </div>
            )}

            {isJobs && (
              <div className="mt-10">
                {/* Most recent booking */}
                {currentVendor.completedBookings?.length > 0 && (
                  <div className="">
                    <div className="flex items-center gap-x-2">
                      <p className="font-medium">Most Recent Job</p>
                      <div className="h-2 w-2 rounded-full bg-shuttlelaneGold"></div>
                    </div>

                    <div className="h-auto w-full rounded-lg allRoundBoxShadow overflow-hidden mt-4">
                      {currentVendor.completedBookings?.length > 0 && (
                        <>
                          <div className="flex items-center justify-center h-[220px] min-h-[220px] max-h-[220px] w-full rounded-tr-lg rounded-tl-lg">
                            <GoogleMapsWithDirections
                              pickupAddress={
                                currentVendor.completedBookings[0]?.booking
                                  ?.pickupAddress
                              }
                              pickupCoordinates={
                                currentVendor.completedBookings[0]?.booking
                                  ?.pickupCoordinates
                              }
                              dropoffAddress={
                                currentVendor.completedBookings[0]?.booking
                                  ?.dropoffAddress
                              }
                              dropoffCoordinates={
                                currentVendor.completedBookings[0]?.booking
                                  ?.dropoffCoordinates
                              }
                            />
                          </div>

                          <div className="flex items-center justify-between p-4">
                            <div className="flex items-center gap-x-2">
                              <div className="h-14 w-14 rounded-lg bg-white shadow-lg flex items-center justify-center">
                                <MdAirplanemodeActive size={20} className="" />
                              </div>

                              <div className="flex flex-col gap-y-1">
                                <small className="font-semibold">
                                  {
                                    currentVendor?.completedBookings[0]?.booking
                                      ?.pickupAddress
                                  }
                                </small>
                                <small className="">
                                  {moment(
                                    currentVendor?.completedBookings[0]?.booking
                                      ?.pickupDate
                                  ).format("DD MM, YYYY")}{" "}
                                  .{" "}
                                  {moment(
                                    currentVendor?.completedBookings[0]?.booking
                                      ?.pickupTime
                                  ).format("H:MM A")}
                                </small>
                                <small className="text-green-500">
                                  {
                                    currentVendor?.completedBookings[0]
                                      ?.bookingStatus
                                  }
                                </small>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}

                {/* Bookings */}
                {/* Recent Bookings */}
                <div className="mt-11 w-full">
                  <div className="w-full rounded-lg border-[1.3px] lg:border-[.3px] p-3 border-gray-100 h-auto">
                    <div className="flex items-baseline justify-between">
                      <div className="flex items-center gap-x-2">
                        <p className="font-medium">
                          Completed Bookings -{" "}
                          {currentVendor.completedBookings?.length}
                        </p>
                        <div className="h-2 w-2 rounded-full bg-shuttlelaneGold"></div>
                      </div>
                    </div>

                    <div className="overflow-x-scroll shuttlelaneScrollbarHoriz shuttlelaneScrollbar">
                      {/* Table header */}
                      <div className="flex justify-between items-baseline mb-2 border-b-[.3px] border-b-gray-100 text-gray-400 mt-2">
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Booking Ref
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Passenger
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Pickup Location
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Pickup Date & Time
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Booking Type
                        </p>
                      </div>

                      {currentVendor.completedBookings?.map((booking) => (
                        <div className="cursor-pointer flex justify-between items-baseline mb-2 pb-2 border-b-[.3px] border-b-gray-100 text-shuttlelaneBlack mt-4">
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {booking?.bookingReference}
                          </p>
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {booking?.user?.firstName ?? booking?.firstName}{" "}
                            {booking?.user?.lastName ?? booking?.lastName}
                          </p>
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {booking?.booking?.pickupAddress}
                          </p>
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {moment(booking?.pickupDate).format("MMM DD, YYYY")}
                            , {moment(booking?.pickupTime).format("H:MM A")}
                          </p>
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {booking?.bookingType}
                          </p>
                        </div>
                      ))}

                      {currentVendor.completedBookings?.length < 1 && (
                        <div className="flex justify-center items-center h-full w-full mb-2 pb-2 text-shuttlelaneBlack mt-4">
                          <p className="w-full text-xs text-center">
                            {currentVendor.companyName} has not completed any
                            bookings just yet...
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isFleet && (
              <div className="mt-10">
                {/* Fleet */}
                <div className="mt-11 w-full">
                  <div className="w-full rounded-lg border-[1.3px] lg:border-[.3px] p-3 border-gray-100 h-auto">
                    <div className="flex items-baseline justify-between">
                      <div className="flex items-center gap-x-2">
                        <p className="font-medium">
                          Fleet - {currentVendor.fleet?.length}
                        </p>
                        <div className="h-2 w-2 rounded-full bg-shuttlelaneGold"></div>
                      </div>
                    </div>

                    <div className="overflow-x-scroll shuttlelaneScrollbarHoriz shuttlelaneScrollbar">
                      {/* Table header */}
                      <div className="flex justify-between items-baseline mb-2 border-b-[.3px] border-b-gray-100 text-gray-400 mt-2">
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Name
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Plate Number
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Model (Type)
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Year
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Color
                        </p>
                      </div>

                      {currentVendor.fleet?.map((fleet) => (
                        <div className="cursor-pointer flex justify-between items-baseline mb-2 pb-2 border-b-[.3px] border-b-gray-100 text-shuttlelaneBlack mt-4">
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {fleet?.carName}
                          </p>
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {fleet?.plateNumber}
                          </p>
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {fleet?.carModel} ({fleet?.carType})
                          </p>
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {fleet?.carYear}
                          </p>
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {fleet?.carColor}
                          </p>
                        </div>
                      ))}

                      {currentVendor.fleet?.length < 1 && (
                        <div className="flex justify-center items-center h-full w-full mb-2 pb-2 text-shuttlelaneBlack mt-4">
                          <p className="w-full text-xs text-center">
                            {currentVendor.companyName} has not added any cars
                            to their fleet just yet...
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isDrivers && (
              <div className="mt-10">
                {/* Vendor drivers */}
                <div className="mt-11 w-full">
                  <div className="w-full rounded-lg border-[1.3px] lg:border-[.3px] p-3 border-gray-100 h-auto">
                    <div className="flex items-baseline justify-between">
                      <div className="flex items-center gap-x-2">
                        <p className="font-medium">
                          Vendor Drivers - {currentVendor.drivers?.length}
                        </p>
                        <div className="h-2 w-2 rounded-full bg-shuttlelaneGold"></div>
                      </div>
                    </div>

                    <div className="overflow-x-scroll shuttlelaneScrollbarHoriz shuttlelaneScrollbar">
                      {/* Table header */}
                      <div className="flex justify-between items-baseline mb-2 border-b-[.3px] border-b-gray-100 text-gray-400 mt-2">
                        <p className="min-w-[200px] w-[200px] lg:w-[25%] text-xs">
                          Image
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[25%] text-xs">
                          Full Name
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[25%] text-xs">
                          Phone Number
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[25%] text-xs">
                          Email Address
                        </p>
                      </div>

                      {currentVendor.drivers?.map((driver) => (
                        <div className="cursor-pointer flex justify-between items-baseline mb-2 pb-2 border-b-[.3px] border-b-gray-100 text-shuttlelaneBlack mt-4">
                          <p className="min-w-[200px] w-[200px] lg:w-[25%] text-xs">
                            <div className="h-10 w-10 rounded-full overflow-hidden bg-shuttlelanePurple text-white flex items-center justify-center">
                              <img
                                src={driver?.image}
                                alt={`${
                                  driver?.firstName && driver?.firstName
                                } ${driver?.lastName && driver?.lastName} ${
                                  driver?.companyName && driver?.companyName
                                }`}
                                className="h-full w-full object-cover"
                              />
                            </div>
                          </p>
                          <p className="min-w-[200px] w-[200px] lg:w-[25%] text-xs">
                            {driver?.firstName} {driver?.lastName}
                          </p>
                          <p className="min-w-[200px] w-[200px] lg:w-[25%] text-xs">
                            {driver?.mobile}
                          </p>

                          <p className="min-w-[200px] w-[200px] lg:w-[25%] text-xs">
                            {driver?.email}
                          </p>
                        </div>
                      ))}

                      {currentVendor.drivers?.length < 1 && (
                        <div className="flex justify-center items-center h-full w-full mb-2 pb-2 text-shuttlelaneBlack mt-4">
                          <p className="w-full text-xs text-center">
                            {currentVendor.companyName} has not added any
                            drivers just yet...
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal>

      {/* Main content goes here */}
      <div className="w-full min-h-screen lg:pl-[6%] bg-[#fff] text-shuttlelaneBlack">
        <div className="px-7 py-5 relative">
          {/* Top bar */}
          <AdminTopBar
            isNavbarOpen={isNavbarOpen}
            setIsNavbarOpen={setIsNavbarOpen}
          />

          {/* Main content */}
          <div className="mt-24 pt-2">
            <div className="flex gap-x-5">
              {/* Booking Summary - Total number of vendors */}
              <div className="w-full">
                {/* Bar Chart */}
                <div className="w-full">
                  <div className="w-full rounded-lg border-[1.3px] lg:border-[.3px] p-3 border-gray-100 h-auto">
                    <div className="flex items-baseline justify-between">
                      <div className="flex items-center gap-x-2">
                        <p className="font-medium">
                          Total Vendors - {vendors?.length}
                        </p>
                        <div className="h-2 w-2 rounded-full bg-shuttlelaneGold"></div>
                      </div>
                      {/* <p className="text-sm underline offset-7">2023</p> */}
                    </div>

                    {/* Area chart */}
                    <div className="mt-2 text-xs">
                      <Chart
                        options={state.options}
                        series={state.series}
                        type="area"
                        width={"100%"}
                        height={250}
                      />
                    </div>
                  </div>
                </div>

                {/* Vendors */}
                <div className="w-full">
                  {/* Searchbar */}
                  {/* <div className="flex items-center gap-x-3 border-[1.3px] lg:border-[.3px] border-gray-300 rounded-lg px-2 my-2 lg:w-1/4 w-full">
                    <BiSearch size={16} className="text-gray-400 rotate-90" />
                    <input
                      type="search"
                      placeholder="Search"
                      className="w-full h-8 bg-transparent text-xs focus:outline-none placeholder:text-xs placeholder:text-gray-400"
                    />
                  </div> */}

                  {suspendedVendors?.length > 0 && (
                    <div className="mt-7 w-full rounded-lg border-[1.3px] lg:border-[.3px] p-3 border-gray-100 h-auto">
                      <div className="flex items-baseline justify-between">
                        <div className="flex items-center gap-x-2">
                          <p className="font-medium">Suspended Vendors</p>
                          <div className="h-2 w-2 rounded-full bg-shuttlelanePurple"></div>
                        </div>
                      </div>

                      {/* Table header */}
                      <div className="flex justify-between items-baseline mb-2 border-b-[.3px] border-b-gray-100 text-gray-400 mt-2">
                        <p className="w-[200px] lg:w-[25%] text-xs">
                          Company name
                        </p>
                        <p className="w-[200px] lg:w-[25%] text-xs">
                          Email Address
                        </p>
                        <p className="w-[200px] lg:w-[25%] text-xs">
                          Contact Number
                        </p>
                        {/* <p className="w-[200px] lg:w-[25%] text-xs">Last Booking</p> */}
                        {admin?.role !== "Blogger" && (
                          <p className="w-[200px] lg:w-[25%] text-xs">
                            Actions
                          </p>
                        )}
                      </div>

                      {/* Table body - Vendor card */}
                      {suspendedVendors?.map((vendor) => (
                        <div className="flex justify-between items-baseline mb-2 pb-2 border-b-[.3px] border-b-gray-100 text-shuttlelaneBlack mt-4">
                          <p
                            onClick={() => {
                              setCurrentVendor(vendor);
                              setIsVendorDetailModalOpen(true);
                            }}
                            className={`w-[200px] cursor-pointer lg:w-[25%] text-xs ${
                              isLoading && "text-gray-400"
                            }`}
                          >
                            {vendor?.companyName}
                          </p>
                          <p
                            onClick={() => {
                              setCurrentVendor(vendor);
                              setIsVendorDetailModalOpen(true);
                            }}
                            className={`w-[200px] cursor-pointer lg:w-[25%] text-xs ${
                              isLoading && "text-gray-400"
                            }`}
                          >
                            {vendor?.companyEmail}
                          </p>
                          <p
                            onClick={() => {
                              setCurrentVendor(vendor);
                              setIsVendorDetailModalOpen(true);
                            }}
                            className={`w-[200px] cursor-pointer lg:w-[25%] text-xs ${
                              isLoading && "text-gray-400"
                            }`}
                          >
                            {vendor?.contactMobile}
                          </p>
                          {/* <p className="w-[200px] lg:w-[25%] text-xs">
                        12 November 2023
                      </p> */}
                          {admin?.role !== "Blogger" && (
                            <div className="w-[180px] lg:w-[25%] flex items-center gap-x-3">
                              {!isLoading ? (
                                <div className="flex flex-row items-center gap-x-2">
                                  <button
                                    onClick={() =>
                                      handleUnsuspendVendor(vendor?._id)
                                    }
                                    className="h-7 w-28 p-2 text-white bg-shuttlelanePurple rounded-lg text-xs"
                                  >
                                    Unsuspend
                                  </button>
                                  <button
                                    onClick={() => deleteVendor(vendor?._id)}
                                    className="text-xs"
                                  >
                                    <AiFillDelete
                                      size={16}
                                      className="text-red-500"
                                    />
                                  </button>
                                </div>
                              ) : (
                                <ImSpinner2
                                  size={16}
                                  className="text-gray-400"
                                />
                              )}
                            </div>
                          )}
                        </div>
                      ))}

                      {suspendedVendors?.length < 1 && (
                        <div className="flex justify-center">
                          <p className="text-center text-sm">
                            No data to show for now...
                          </p>
                        </div>
                      )}
                    </div>
                  )}

                  <div className="mt-7 w-full rounded-lg border-[1.3px] lg:border-[.3px] p-3 border-gray-100 h-auto">
                    <div className="flex items-baseline justify-between">
                      <div className="flex items-center gap-x-2">
                        <p className="font-medium">Approved Vendors</p>
                        <div className="h-2 w-2 rounded-full bg-shuttlelanePurple"></div>
                      </div>
                    </div>

                    {/* Table header */}
                    <div className="flex justify-between items-baseline mb-2 border-b-[.3px] border-b-gray-100 text-gray-400 mt-2">
                      <p className="w-[200px] lg:w-[25%] text-xs">
                        Company name
                      </p>
                      <p className="w-[200px] lg:w-[25%] text-xs">
                        Email Address
                      </p>
                      <p className="w-[200px] lg:w-[25%] text-xs">
                        Contact Number
                      </p>
                      {/* <p className="w-[200px] lg:w-[25%] text-xs">Last Booking</p> */}
                      {admin?.role !== "Blogger" && (
                        <p className="w-[200px] lg:w-[25%] text-xs">Actions</p>
                      )}
                    </div>

                    {/* Table body - Vendor card */}
                    {vendors?.map((vendor) => (
                      <div className="flex justify-between items-baseline mb-2 pb-2 border-b-[.3px] border-b-gray-100 text-shuttlelaneBlack mt-4">
                        <p
                          onClick={() => {
                            setCurrentVendor(vendor);
                            setIsVendorDetailModalOpen(true);
                          }}
                          className={`w-[200px] cursor-pointer lg:w-[25%] text-xs ${
                            isLoading && "text-gray-400"
                          }`}
                        >
                          {vendor?.companyName}
                        </p>
                        <p
                          onClick={() => {
                            setCurrentVendor(vendor);
                            setIsVendorDetailModalOpen(true);
                          }}
                          className={`w-[200px] cursor-pointer lg:w-[25%] text-xs ${
                            isLoading && "text-gray-400"
                          }`}
                        >
                          {vendor?.companyEmail}
                        </p>
                        <p
                          onClick={() => {
                            setCurrentVendor(vendor);
                            setIsVendorDetailModalOpen(true);
                          }}
                          className={`w-[200px] cursor-pointer lg:w-[25%] text-xs ${
                            isLoading && "text-gray-400"
                          }`}
                        >
                          {vendor?.contactMobile}
                        </p>
                        {/* <p className="w-[200px] lg:w-[25%] text-xs">
                        12 November 2023
                      </p> */}
                        {admin?.role !== "Blogger" && (
                          <div className="w-[180px] lg:w-[25%] flex items-center gap-x-3">
                            {!isLoading ? (
                              <div className="flex flex-row items-center gap-x-2">
                                <button
                                  onClick={() =>
                                    handleSuspendVendor(vendor?._id)
                                  }
                                  className="h-7 w-28 p-2 text-white bg-shuttlelanePurple rounded-lg text-xs"
                                >
                                  Suspend
                                </button>
                                <button
                                  onClick={() => deleteVendor(vendor?._id)}
                                  className="text-xs"
                                >
                                  <AiFillDelete
                                    size={16}
                                    className="text-red-500"
                                  />
                                </button>
                              </div>
                            ) : (
                              <ImSpinner2 size={16} className="text-gray-400" />
                            )}
                          </div>
                        )}
                      </div>
                    ))}

                    {vendors?.length < 1 && (
                      <div className="flex justify-center">
                        <p className="text-center text-sm">
                          No data to show for now...
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboardVendorsPage;
